<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.2"
    stroke="currentColor"
    class="w-6 h-6 color-stroke"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
</template>

<script>
export default {
  name: "ClockIcon",
}
</script>
<style scoped>
.color-stroke path {
  stroke: rgb(239, 137, 43);
}
</style>
